// extracted by mini-css-extract-plugin
export default {"Collapse":"Zd5Wg0b8"};